import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import AmbientBackground from '../common/AmbientBackground';
import Button from '../common/Button';

const NextSteps: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AmbientBackground backgroundImage="/bg-still-deep.png" className="min-h-[calc(100vh-8rem)]">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="max-w-4xl mx-auto px-6 py-16 flex flex-col items-center justify-center min-h-[calc(100vh-8rem)]"
      >
        <div className="text-center">
          <h1 className="font-display text-4xl md:text-5xl font-semibold text-ink dark:text-parchment mb-6">
            Reading Saved Successfully!
          </h1>
          <p className="text-lg text-ink/90 dark:text-parchment/60 mb-12">
            Your reading has been saved to your journal. What would you like to do next?
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
          <div
            className="rounded-xl p-6 backdrop-blur-md"
            style={{
              background: 'rgba(245, 240, 232, 0.12)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
            }}
          >
            <h3 className="text-xl font-display font-bold text-sun dark:text-ember mb-3">
              Start a New Reading
            </h3>
            <p className="text-ink/90 dark:text-parchment/60 mb-6 flex-grow">
              Ready to explore another question or situation? Start a fresh reading with different spreads and insights.
            </p>
            <Button
              variant="primary"
              onClick={() => navigate('/new-reading')}
              fullWidth
            >
              New Reading
            </Button>
          </div>

          <div
            className="rounded-xl p-6 backdrop-blur-md"
            style={{
              background: 'rgba(245, 240, 232, 0.12)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
            }}
          >
            <h3 className="text-xl font-display font-bold text-sun dark:text-ember mb-3">
              View Your Journal
            </h3>
            <p className="text-ink/90 dark:text-parchment/60 mb-6 flex-grow">
              Review your saved readings, reflect on your journey, and track your insights over time.
            </p>
            <Button
              variant="secondary"
              onClick={() => navigate('/history')}
              fullWidth
            >
              Open Journal
            </Button>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Button
            variant="outline"
            onClick={() => navigate('/center')}
          >
            Return to Tarot Center
          </Button>
        </div>
      </motion.div>
    </AmbientBackground>
  );
};

export default NextSteps;
